'use strict';

var mergePrototypes = function mergePrototypes(target, srcs, preserveTargetPrototype) {
  var prototypeMethods = {};
  srcs.forEach(function (src) {
    Object.getOwnPropertyNames(src.prototype).forEach(function (name) {
      if (name !== 'constructor' && (!target.prototype[name] || !preserveTargetPrototype)) {
        prototypeMethods[name] = src.prototype[name];
      }
    });
  });
  Object.assign(target.prototype, prototypeMethods);
};

module.exports = mergePrototypes;